/**
 * ForgotPasswordHero — left-panel content for AUTH-03 Forgot Password.
 *
 * "Account Recovery" label + "Reset your access / password in seconds." heading.
 * Figma frame 79:2 hero column.
 */
export function ForgotPasswordHero() {
  return (
    <div className="flex flex-col gap-4">
      <p className="text-base text-[var(--text-secondary)]">Account Recovery</p>
      <p className="text-lg leading-snug text-[var(--text-primary)]">
        Reset your access
        <br />
        password in seconds.
      </p>
    </div>
  );
}
